import type {
  CheckConclusionState,
  CheckStatusState,
  MergeableState,
  MergeStateStatus,
  PullRequestState,
} from '@/lib/github/graphql/types';
import type { Reviewer } from '@/types/github';
import type { StatusState } from '@octokit/graphql-schema';

export const MERGE_METHODS = ['merge', 'squash', 'rebase'] as const;

export type MergeMethod = (typeof MERGE_METHODS)[number];

export type PullRequest = {
  nodeId: string;
  number: number;
  title: string;
  author: { login: string; avatarUrl: string };
  createdAt: string;
  updatedAt: string;
  closedAt: string | null;
  mergedAt: string | null;
  draft: boolean;
  url: string;
  body: string;
  state: PullRequestState;
  changedFiles: number;
  additions: number;
  deletions: number;
  commits: number;
  review_comments: number;
  comments: number;
  mergeCommitSha?: string | null;
  labels?: Array<{
    name: string;
    color: string;
    description: string;
    id: string;
    isDefault: boolean;
    url: string;
  }>;
  autoMerge?: { enabledAt: string; mergeMethod: MergeMethod } | undefined;
  merged: boolean;
  mergeable: MergeableState;
  rebaseable: boolean;
  mergeStateStatus: MergeStateStatus;
  mergedBy: { login: string; avatarUrl: string } | null;
  reviewers: Reviewer[];
  repository: {
    name: string;
    owner: string;
    url?: string;
  };
  head: { ref: string; sha: string };
  base: { ref: string; sha: string };
  headRef: string;
  statusCheckRollup?: Array<{
    state?: CheckConclusionState | CheckStatusState | StatusState;
    context?: string;
    description?: string;
    targetUrl?: string;
  }>;
  viewerCanEnableAutoMerge?: boolean;
  repositoryAutoMergeAllowed?: boolean;
  allowedMergeMethods?: MergeMethod[];
  canEnableAutoMerge?: boolean;
  repositoryViewerPermission?: string | null;
};
